import * as types from './threadActionTypes';

const initialState = {
  threadData: null,
  threadList: [],
  createThreadData: null,
  createThreadError: null,
  updateThreadData: null,
  updateThreadError: null,
  deleteThreadData: null,
  deleteThreadError: null,
};

export const threadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_THREAD_DATA:
      return {
        ...state,
        threadData: action.payload || null,
        threadList: action.payload?.ThreadList || action.payload?.Threads || [],
      };
    case types.GET_THREAD_ERROR:
      return {
        ...state,
        threadData: null,
        threadList: [],
      };
    case types.CREATE_THREAD_DATA:
      return {
        ...state,
        createThreadData: action.payload,
        createThreadError: null,
      };
    case types.CREATE_THREAD_ERROR:
      return {
        ...state,
        createThreadData: null,
        createThreadError: action.payload,
      };
    case types.UPDATE_THREAD_DATA:
      return {
        ...state,
        updateThreadData: action.payload,
        updateThreadError: null,
      };
    case types.UPDATE_THREAD_ERROR:
      return {
        ...state,
        updateThreadData: null,
        updateThreadError: action.payload,
      };
    case types.DELETE_THREAD_DATA:
      return {
        ...state,
        deleteThreadData: action.payload,
        deleteThreadError: null,
      };
    case types.DELETE_THREAD_ERROR:
      return {
        ...state,
        deleteThreadData: null,
        deleteThreadError: action.payload,
      };
    default:
      return state;
  }
};
